import React from "react";
import { Helmet } from "react-helmet";

import PropTypes from "prop-types";

const SEO = ({ title, desc, keywords, url, type, img,children }) => {
  return (
    <Helmet>
      <title>{title}</title>
      <meta name="title" content={title} />
      <meta name="description" content={desc} />
      <meta name="keywords" content={keywords} />
      <link rel="canonical" href={url} />

      {/* Open Graph / Facebook  */}
      <meta property="og:type" content={type} />
      <meta property="og:title" content={title} />
      <meta property="og:url" content={url} />
      <meta property="og:description" content={desc} />
      <meta property="og:image" content={img} />

      {/* Twitter  */}
      <meta property="twitter:card" content="summary_large_image" />
      <meta property="twitter:title" content={title} />
      <meta property="twitter:url" content={url} />
      <meta property="twitter:description" content={desc} />
      <meta property="twitter:image" content={img} />

      {/* Children For Adsense Script tags */}
      {children}
    </Helmet>
  );
};

SEO.propTypes = {
  title: PropTypes.string,
  desc: PropTypes.string,
  keywords: PropTypes.string,
  url: PropTypes.string,
  type: PropTypes.string,
  img: PropTypes.string,
};

export default SEO;
